module.exports = __webpack_public_path__ + "img/product13.c350bbe6.jpg";